import React, { lazy, Suspense, useState, useEffect } from "react";
import { Switch, Route, useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { authContext } from './data/authContext';
import { homePageService } from "./jwt/_services/home-page-service";
import CryptoJS from "crypto-js";
import './assets/scss/mainStyle.scss';
import { CognitoUser, AuthenticationDetails, CognitoUserPool } from "amazon-cognito-identity-js";
import { decryptData, EMAIL_AWS_COGNITO, encryptData, getCharityIdFromPathname, getSecret, PASSWORD_AWS_COGNITO, USER_NAME_AWS_COGNITO } from "../src/common";
import ConnectionError from './views/error-pages/connection-error';
import PageConnectionError from './views/error-pages/page-connection-error';
import * as homepage from './redux/actions/homepageAction';
import * as user from './redux/actions/userAction';
import * as zakatCalc from './redux/actions/zakatCalcAction';
import * as zakat from './redux/actions/zakatActions';
import { APP_FLOW, config, sessionTimeUnit, AWS_REGION, paths, PLEDGE_CHARITY_ID, SESSION_EXPIRE_DURATION, REACT_APP_CRYPTO_JS_PASSWORD } from "./common/constant";
import { fidyahActions } from "./redux/reducers/fidyah-slice";
import Pool from './aws-pool/login-pool';
import { Amplify } from 'aws-amplify';
import loginPool from "./aws-pool/login-pool";
import * as userActions from './redux/actions/userAction';
import SlickSlider from "./views/slider/slider";
import { useIdleTimer } from "react-idle-timer";
import sessionExpire from "./views/error-pages/session-expire";
import Loader from "./views/MUIS/loader";
import SessionExpire from "./views/error-pages/session-expire";

Amplify.configure({
  Auth: {
    region: AWS_REGION,
    userPoolId: config.AWS_COGNITO_LOGIN_POOL.USER_POOL_ID,
    userPoolWebClientId: config.AWS_COGNITO_LOGIN_POOL.CLIENT_ID
  }
});

const isWakafOrigin = window.location.origin.toLocaleLowerCase().includes(config.ROUTES.WAKAF);
const isPledgeOrigin = window.location.pathname.toLocaleLowerCase().includes(config.ROUTES.PLEDGE);

const App = () => {
  const [state, setState] = useState({
    url: window.location.host,
    isDataLoaded: false,
    settingsData: [],
    isOnline: window.navigator.onLine,
    isAuthorised: false,
    tokenSecretKey: "",
    charityId: '',
    isSessionExpired: false
  });

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const homepageData = useSelector(state => state.homepageReducer);
  const userData = useSelector(state => state.userReducer);

  const getHomePageData = async () => {
    const response = await homePageService.getHomePageConfig()
    console.log(response,'response')
    if(response) {
      checkForRateChangesAndRedirect(response);
      if(homepageData?.charityId) {
        if(homepageData.charityId != response.charity.charityId) {
          clearReduxStore();
        }
      }
      dispatch(homepage.setCharityId(response.charity.charityId));
      setState(prev => ({ ...prev, isDataLoaded: true, isSessionExpired: false }));
    } else {
      setState(prev => ({ ...prev, isDataLoaded: true,  isSessionExpired: false }));
    }
  };

  const checkForRateChangesAndRedirect = (response) => {
    if (
      Boolean(homepageData?.muisZakatHarta?.nisab?.value) &&
      Boolean(homepageData?.muisZakatFitrah?.minAmount) &&
      Boolean(homepageData?.muisZakatFitrah?.maxAmount) &&
      Boolean(homepageData?.muisZakatFidyah?.fidyahPerDay) &&
      Boolean(homepageData?.muisKaffarah?.kaffarahPerDay) &&
      Boolean(homepageData?.muisKaffarah?.jimakNoOfPeople) &&
      Boolean(homepageData?.muisKaffarah?.nazarNoOfPeople)
    ) {
      if (
        response.muisZakatFidyah?.fidyahPerDay !== homepageData.muisZakatFidyah?.fidyahPerDay ||
        response.muisKaffarah?.kaffarahPerDay !== homepageData.muisKaffarah?.kaffarahPerDay ||
        response.muisKaffarah?.jimakNoOfPeople !== homepageData.muisKaffarah?.jimakNoOfPeople ||
        response.muisKaffarah?.nazarNoOfPeople !== homepageData.muisKaffarah?.nazarNoOfPeople ||
        response.muisZakatHarta?.nisab?.value !== homepageData.muisZakatHarta?.nisab?.value ||
        response.muisZakatFitrah?.minAmount !== homepageData.muisZakatFitrah?.minAmount ||
        response.muisZakatFitrah?.maxAmount !== homepageData.muisZakatFitrah?.maxAmount
      ) {
        console.log("Nisab, Fitrah or Fidyah Rate(s) Changed:");
        dispatch(homepage.setHomePageData({ ...response, isRateChanged: true }));
        dispatch(zakatCalc.updateNisabValue(response?.muisZakatHarta?.nisab?.value));

        if (window.location.href.search(/fidyah/gi) !== -1) {
          history.replace('/fidyah/session-expire');
        } else if (window.location.href.search(/kaffarah/gi) !== -1) {
          history.replace('/kaffarah/session-expire');
        } else {
          history.replace('/session-expire');
        }
      } else {
        dispatch(homepage.setHomePageData({ ...response, isRateChanged: false }));
        dispatch(zakatCalc.updateNisabValue(response?.muisZakatHarta?.nisab?.value));
      }
    } else {
      dispatch(homepage.setHomePageData({ ...response, isRateChanged: false }));
      dispatch(zakatCalc.updateNisabValue(response?.muisZakatHarta?.nisab?.value));
    }
  };

  const getAuthorizerDetails = async () => {
    let poolId = await getSecret(`/${config.TYPE.toLowerCase()}${paths.AuthorizerAccessKey}`).then((key) => decryptData(key));
    let clientId = await getSecret(`/${config.TYPE.toLowerCase()}${paths.AuthorizerClientId}`).then((key) => decryptData(key));
    return {
      UserPoolId: poolId,
      ClientId: clientId
    };
  };

  const getAuthorisedHomePage = (isLoadHomePage, poolDetails) => {
    const user = new CognitoUser({
      Username: atob(USER_NAME_AWS_COGNITO),
      Pool: new CognitoUserPool(poolDetails),
    });

    const authDetails = new AuthenticationDetails({
      Username: atob(USER_NAME_AWS_COGNITO),
      Password: atob(PASSWORD_AWS_COGNITO),
    });

    user.authenticateUser(authDetails, {
      onSuccess: (data) => {
        authContext.AccessToken = data.accessToken.jwtToken;
        authContext.IdToken = data.idToken.jwtToken;
        authContext.RefreshToken = data.refreshToken.token;
        if (isLoadHomePage) {
          if (state.charityId && state.charityId !== config.MUIS_CHARITY_ID && (isWakafOrigin || isPledgeOrigin)) {
            homePageService.gethomePageConfiguration(state.charityId)
              .then((response) => {
                dispatch(homepage.setHomePageData({ ...response, isRateChanged: false }));
                setState(prev => ({ ...prev, isDataLoaded: true }));
              });
          } else {
            getHomePageData();
          }
        } else {
          setState(prev => ({ ...prev, isDataLoaded: true }));
        }
        setState(prev => ({ ...prev, isAuthorised: true }));
      },
      onFailure: (error) => {
        console.error("onFailure: ", error);
      },
      newPasswordRequired: (response) => {
        const userAttributes = {
          'email': EMAIL_AWS_COGNITO
        };
        console.log("newPasswordRequired: ", userAttributes, response);
        user.completeNewPasswordChallenge(PASSWORD_AWS_COGNITO, userAttributes, {
          onSuccess: (result) => {
            console.log("NEW PASSWORD COMPLETED: New Password Set");
          },
          onFailure: (err) => {
            console.error(err);
          }
        });
      },
    });
  };

  const updateConnection = (status) => {
    setState(prev => ({ ...prev, isOnline: status }));
  };

  const clearReduxStore = () => {
    dispatch(zakat.resetFitrahData());
    dispatch(zakat.resetZakatData());
    dispatch(zakatCalc.resetZakatCalcData());
    dispatch(fidyahActions.reset());
    dispatch(user.updateBusinessUser(null));
    dispatch(user.updateIsDeceased(null));
    dispatch(user.updateIsOthers(null));
    dispatch(user.resetUserData());
    localStorage.clear();
    sessionStorage.clear();
  };

  useEffect(() => {
    console.log('Debugging: App Mounted');
    if (userData?.transactionNo && userData?.trxCreationTime) {
      const creationTime = new Date(userData.trxCreationTime);
      console.log('Transaction in progress: creation time - ', creationTime);
      let timePassed = parseInt(((Date.now() - userData.trxCreationTime) / 1000) / 60);
      if (timePassed > sessionTimeUnit.time) {
        console.log(`Transaction expired (Older than ${sessionTimeUnit.time}m): creation time - `, creationTime);
        if (sessionStorage.getItem("appReloaded") === 'true') {
          sessionStorage.removeItem('appReloaded');
          clearReduxStore();
          console.log('appReloaded - true');
        } else {
          const user = loginPool.getCurrentUser();
          Boolean(user) && user?.signOut();
          clearReduxStore();
          window.sessionStorage.clear();
          sessionStorage.setItem('appReloaded', true);
          window.location.reload();
        }
      }
    }

    getAuthorizerDetails().then(poolDetails => {
      if (window.location.pathname.indexOf('/receipt') !== -1 || window.location.pathname.indexOf('/register') !== -1) {
        getAuthorisedHomePage(false, poolDetails);
      } else {
        getAuthorisedHomePage(true, poolDetails);
      }

      window.addEventListener('offline', () => updateConnection(false));
      window.addEventListener('online', () => updateConnection(true));

      getSecret(`/${config.TYPE.toLowerCase()}${paths.SessionKey}`)
        .then(key => decryptData(key))
        .then((secretKey) => {
          setState(prev => ({ ...prev, tokenSecretKey: secretKey }));
        });
    });

    dispatch(userActions.setLoginMendatory(false));

    return () => {
      window.removeEventListener('offline', () => updateConnection(false));
      window.removeEventListener('online', () => updateConnection(true));
    };
  }, []);

  // Idle timer cases handling
  const onIdle = () => {
    // Do some idle action like log out your user
    // sessionStorage.setItem('isSessionExpired', true);
    // localStorage.setItem('isSessionExpired', true);
    // history.push({ pathname: '/session-expire', state: { isSessionExpired: true, fromUrl: window.location.pathname } });
    setState(prev => ({ ...prev, isSessionExpired: true }));
  }

  const onAction = (event) => {
    // Do something when a user triggers a watched event
    // console.log('onAction:', event);
  }

  const {
    start,
  } = useIdleTimer({
    onIdle,
    onAction,
    timeout: SESSION_EXPIRE_DURATION,
    // promptBeforeIdle: 2000,
    debounce: 1000, // 1sec
    throttle: 0,
    eventsThrottle: 200,
    startOnMount: true, // 
    startManually: true, // StartOnMount wasn't working as expected hence enabled this
    stopOnIdle: false,
    crossTab: true,
    name: 'idle-timer',
    syncTimers: 0,
    leaderElection: false
  })

  useEffect(() => {
    start(); 
    if (window.location.pathname.includes('/mosque') && userData?.transactionPassed) {
      dispatch(fidyahActions.reset());
      dispatch(zakat.resetZakatData());
      dispatch(zakatCalc.resetZakatCalcData());
      dispatch(user.updateTransactionStatus(false));
      localStorage.removeItem('selectedOption')
      sessionStorage.clear()
      const poolUser = Pool.getCurrentUser();
      if (!Boolean(poolUser)) {
        dispatch(user.resetUserData());
      }
    }
  }, []);

  return (
    <>
      {!state.isDataLoaded && (
          <div className='c-loader'><Loader /></div>
      )}
      {state.isSessionExpired ? (
        <SessionExpire />
      ) : (
        <Switch>
          <Route path="/" component={SlickSlider} />
          <Route exact path="/not-found" component={PageConnectionError} />
          <Route exact path="*" component={PageConnectionError} />
        </Switch>
      )}
    </>
  );
};

export default App;